var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorBattery75(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20667 10.1666L5.12333 7.87496L8.33167 7.41663H15.2067L17.4983 8.33329C17.6511 8.63885 17.9567 9.34163 17.9567 9.70829C17.9567 10.075 18.8733 10.7777 19.3317 11.0833V12.4583L18.415 13.375L17.4983 15.6666L16.5817 16.125L14.7483 16.5833H9.24833H5.58167L4.665 15.6666L4.20667 10.1666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70664 14.75C9.46353 14.75 9.23037 14.6534 9.05846 14.4815C8.88656 14.3096 8.78998 14.0765 8.78998 13.8333V10.1667C8.78998 9.92355 8.88656 9.69039 9.05846 9.51849C9.23037 9.34658 9.46353 9.25 9.70664 9.25C9.94976 9.25 10.1829 9.34658 10.3548 9.51849C10.5267 9.69039 10.6233 9.92355 10.6233 10.1667V13.8333C10.6233 14.0765 10.5267 14.3096 10.3548 14.4815C10.1829 14.6534 9.94976 14.75 9.70664 14.75ZM6.95664 14.75C6.71353 14.75 6.48037 14.6534 6.30846 14.4815C6.13656 14.3096 6.03998 14.0765 6.03998 13.8333V10.1667C6.03998 9.92355 6.13656 9.69039 6.30846 9.51849C6.48037 9.34658 6.71353 9.25 6.95664 9.25C7.19976 9.25 7.43292 9.34658 7.60483 9.51849C7.77673 9.69039 7.87331 9.92355 7.87331 10.1667V13.8333C7.87331 14.0765 7.77673 14.3096 7.60483 14.4815C7.43292 14.6534 7.19976 14.75 6.95664 14.75ZM18.8733 9.25C18.8733 7.73383 17.6395 6.5 16.1233 6.5H6.03998C4.52381 6.5 3.28998 7.73383 3.28998 9.25V14.75C3.28998 16.2662 4.52381 17.5 6.03998 17.5H16.1233C17.6395 17.5 18.8733 16.2662 18.8733 14.75C19.3595 14.75 19.8259 14.5568 20.1697 14.213C20.5135 13.8692 20.7066 13.4029 20.7066 12.9167V11.0833C20.7066 10.5971 20.5135 10.1308 20.1697 9.78697C19.8259 9.44315 19.3595 9.25 18.8733 9.25ZM17.04 14.75C17.04 15.256 16.6284 15.6667 16.1233 15.6667H6.03998C5.53489 15.6667 5.12331 15.256 5.12331 14.75V9.25C5.12331 8.744 5.53489 8.33333 6.03998 8.33333H16.1233C16.6284 8.33333 17.04 8.744 17.04 9.25V14.75Z",
    fill: "url(#paint0_linear_4487_150482)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4566 14.75C12.2135 14.75 11.9804 14.6534 11.8085 14.4815C11.6366 14.3096 11.54 14.0764 11.54 13.8333V10.1667C11.54 9.92355 11.6366 9.69039 11.8085 9.51849C11.9804 9.34658 12.2135 9.25 12.4566 9.25C12.6998 9.25 12.9329 9.34658 13.1048 9.51849C13.2767 9.69039 13.3733 9.92355 13.3733 10.1667V13.8333C13.3733 14.0764 13.2767 14.3096 13.1048 14.4815C12.9329 14.6534 12.6998 14.75 12.4566 14.75Z",
    fill: "url(#paint1_linear_4487_150482)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4487_150482",
    x1: 5.27872,
    y1: 4.39217,
    x2: 14.3921,
    y2: 30.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59E3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BD64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4487_150482",
    x1: 5.27872,
    y1: 4.39217,
    x2: 14.3921,
    y2: 30.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59E3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BD64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorBattery75);
export default __webpack_public_path__ + "static/media/color-battery-75.548abfac980915b74b574ef8496d64b0.svg";
export { ForwardRef as ReactComponent };